//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import EventBus from "@/event-bus.js";
import {
  GET_ENCUESTAS_BY_PACIENTE_ID,
  GET_PACIENTE_BY_ID
} from "@/graphql/queries/pacientes.js";
import { CREAR_ENCUESTA } from "@/graphql/mutations/pacientes.js";
import { FIND_TIPOS_ENCUESTA } from "@/graphql/queries/encuestas.js";
import { contextualHelp } from "@/utils/contextualHelp.js";
import { date } from "quasar";

export default {
  name: "MisEncuestasList",
  apollo: {
    encuestas: {
      query: GET_ENCUESTAS_BY_PACIENTE_ID,
      variables: {
        cognito_id: null
      },
      update(data) {
        if (data.findPacienteBy) {
          return data.findPacienteBy.encuestas;
        }
        return [];
      },
      skip() {
        return true;
      }
    },
    tiposEncuesta: {
      query: FIND_TIPOS_ENCUESTA,
      update(data) {
        return data.findTiposEncuesta;
      }
    }
  },
  async mounted() {
    EventBus.$emit("page-loaded", { page: "MisEncuestasList" });
    EventBus.$emit("dynamic-help", {
      help: contextualHelp["MisEncuestasList"]
    });
    let user = this.$store.getters["auth/getUser"];
    this.$apollo.queries.encuestas.setVariables({
      cognito_id: user.attributes.sub
    });
    this.$apollo.queries.encuestas.skip = false;
    this.$apollo.queries.encuestas.refetch();
    console.log(user);
    let res = await this.$apollo.query({
      query: GET_PACIENTE_BY_ID,
      variables: {
        id: +user.internal.id
      }
    });
    console.log(res.data.findPacienteBy.medicos);
    this.medicos = res.data.findPacienteBy.medicos;
    this.medicoSelected = this.medicos.length > 0 ? this.medicos[0].id : null;
  },
  data() {
    return {
      encuestas: [],
      columns: [
        {
          name: "tipo_encuesta",
          label: "Tipo Encuesta",
          align: "left",
          field: row => row.tipo_encuesta.descripcion
        },
        {
          name: "fill_at",
          label: "Fecha de Realización",
          align: "left",
          field: row => this.computedDate(row.fill_at)
        },
        {
          name: "estado_encuesta_nombre",
          label: "Estado Encuesta",
          align: "left",
          field: row => row.estado_encuesta.nombre
        },
        {
          name: "resultado",
          label: "Resultado",
          align: "left",
          field: "resultado"
        },
        {
          name: "resultado_numerico",
          label: "Resultado Numérico",
          align: "left",
          field: "resultado_numerico"
        },
        {
          name: "options",
          label: ""
        }
      ],
      showModalMedico: false,
      medicos: [],
      tiposEncuesta: [],
      medicoSelected: null,
      encuestaSelected: null
    };
  },
  methods: {
    completarEncuesta(row) {
      this.$router.push(`/encuestas/${row.id}/rapid3`);
      return;
    },
    computedDate(d) {
      const comDat = d ? date.extractDate(d, "YYYY-MM-DD HH:mm:ss") : null;
      return comDat ? date.formatDate(comDat, "DD/MM/YYYY HH:mm") : "-";
    },
    calculateRowColor(row) {
      switch (row.estado_encuesta.nombre) {
        case "PENDIENTE":
          return "deep-orange";
        case "COMPLETADA":
          return "positive";
        case "REVISADA":
          return "primary";
      }
    },
    readEncuesta(row) {
      this.$router.push({
            path: `/encuestas/${row.id}/rapid3`,
            query: { readOnly: true }
      });
      return;
    },
    async crearEncuesta() {
      console.log("Creo la encuesta");
      console.log(this.medicoSelected);
      try {
        let user = this.$store.getters["auth/getUser"];
        console.log(this.encuestaSelected);
        await this.$apollo.mutate({
          mutation: CREAR_ENCUESTA,
          variables: {
            id_tipo_encuesta: this.encuestaSelected.id,
            id_medico: this.medicoSelected,
            id_paciente: user.internal.id
          }
        });
        this.$q.notify({
          position: "top-right",
          message: "Encuesta creada correctamente",
          color: "positive"
        });
        this.$apollo.queries.encuestas.refetch();
      } catch (e) {
        console.log(e.message);
        this.$q.notify({
          position: "top-right",
          message: e.message,
          color: "negative"
        });
      } finally {
        this.$q.loading.hide();
      }
    },
    showBottomSheet(evt, row) {
      if (this.$q.screen.lt.md) {
        const actions = [];
        if (row.estado_encuesta.nombre === "PENDIENTE") {
          actions.push({
            label: "Completar Encuesta",
            icon: "ballot",
            id: "completarEncuesta",
            classes: "custom-color-sheet"
          });
        } else if (row.estado_encuesta.nombre !== "PENDIENTE") {
          actions.push({
            label: "Ver Encuesta",
            icon: "history",
            id: "verEncuesta",
            classes: "custom-color-sheet"
          });
        }
        this.$q
          .bottomSheet({
            message: "Seleccione una acción: ",
            grid: false,
            actions: actions
          })
          .onOk(action => {
            switch (action.id) {
              case "completarEncuesta":
                this.completarEncuesta(row);
                break;
              case "verEncuesta":
                this.readEncuesta(row);
                break;
            }
          });
      }
    }
  }
};
